(function () {
  'use strict';

  function parseJSON(value, fallback) {
    if (!value) return fallback;
    try { return JSON.parse(value); } catch (error) { return fallback; }
  }

  function normalizePhotos(review) {
    var raw = review && (review.pictures_urls || review.photos || review.images || review.hidden_pictures) || [];
    if (!Array.isArray(raw)) raw = raw ? [raw] : [];
    return raw.map(function (item) {
      if (!item) return null;
      if (typeof item === 'string') return item;
      return item.original || item.huge || item.url || item.src || item.original_url || item.preview_url || item.small || null;
    }).filter(Boolean);
  }

  function isVerifiedPurchase(review) {
    return !!review && (
      review.verified_purchase === true || review.verified_purchase === 'true' ||
      review.verified === true || review.verified === 'true' ||
      review.verified_buyer === true || review.buyer_verified === true
    );
  }

  function renderReviews(root, reviews) {
    var container = root.querySelector('[data-ns-reviews]');
    var empty = root.querySelector('[data-ns-empty-reviews]');
    if (!container) return;
    container.innerHTML = '';

    if (!reviews || !reviews.length) {
      if (empty) empty.classList.add('is-visible');
      return;
    }
    if (empty) empty.classList.remove('is-visible');

    reviews.forEach(function (review) {
      var card = document.createElement('article');
      card.className = 'ns-review';
      card.setAttribute('role', 'listitem');

      var who = document.createElement('div');
      who.className = 'who';
      who.appendChild(document.createTextNode(review.author || review.name || review.reviewer_name || 'Customer'));
      if (isVerifiedPurchase(review)) {
        var badge = document.createElement('span');
        badge.className = 'ns-badge';
        badge.textContent = 'Verified buyer';
        who.appendChild(badge);
      }
      card.appendChild(who);

      var rating = Math.max(0, Math.min(5, Math.round(Number(review.rating) || 0)));
      if (rating) {
        var stars = document.createElement('div');
        stars.className = 'stars';
        stars.setAttribute('aria-label', rating + ' out of 5 stars');
        stars.textContent = '★★★★★'.slice(0, rating);
        card.appendChild(stars);
      }

      var reviewText = review.body || review.content || review.review || '';
      if (reviewText) {
        var body = document.createElement('p');
        body.textContent = reviewText;
        card.appendChild(body);
      }

      var photos = normalizePhotos(review);
      if (photos.length) {
        var row = document.createElement('div');
        row.className = 'ns-review-photos';
        photos.forEach(function (src, index) {
          var link = document.createElement('a');
          link.href = src;
          link.target = '_blank';
          link.rel = 'noopener';
          link.setAttribute('aria-label', 'Open customer photo ' + (index + 1));

          var img = document.createElement('img');
          img.src = src;
          img.alt = 'Customer photo';
          img.loading = 'lazy';
          img.addEventListener('error', function () { link.remove(); });
          link.appendChild(img);
          row.appendChild(link);
        });
        card.appendChild(row);
      }

      container.appendChild(card);
    });
  }

  function closestItemIndex(track) {
    var children = Array.prototype.slice.call(track.children);
    if (!children.length) return 0;
    var trackLeft = track.getBoundingClientRect().left;
    var bestIndex = 0;
    var bestDistance = Infinity;
    children.forEach(function (child, index) {
      var distance = Math.abs(child.getBoundingClientRect().left - trackLeft);
      if (distance < bestDistance) {
        bestDistance = distance;
        bestIndex = index;
      }
    });
    return bestIndex;
  }

  function initCarousel(root, key) {
    var track = root.querySelector('[data-ns-scroll-track="' + key + '"]');
    var counter = root.querySelector('[data-ns-counter="' + key + '"]');
    if (!track) return;

    function updateCounter() {
      var total = track.children.length;
      if (!counter) return;
      counter.textContent = total ? (closestItemIndex(track) + 1) + ' / ' + total : '';
    }

    function move(direction) {
      var children = Array.prototype.slice.call(track.children);
      if (!children.length) return;
      var targetIndex = Math.max(0, Math.min(children.length - 1, closestItemIndex(track) + direction));
      children[targetIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }

    var previous = root.querySelector('[data-ns-scroll-prev="' + key + '"]');
    var next = root.querySelector('[data-ns-scroll-next="' + key + '"]');
    if (previous) previous.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });

    var scheduled = false;
    track.addEventListener('scroll', function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        updateCounter();
      });
    }, { passive: true });
    window.addEventListener('resize', updateCounter);
    updateCounter();
  }

  function initLanding(root) {
    if (!root || root.dataset.nsReady === 'true') return;
    root.dataset.nsReady = 'true';

    renderReviews(root, parseJSON(root.getAttribute('data-reviews'), []));
    ['guide', 'tools', 'reviews'].forEach(function (key) { initCarousel(root, key); });

    var sticky = root.querySelector('[data-ns-sticky]');
    var heroCta = root.querySelector('[data-ns-hero-cta]');
    var stickyStops = Array.prototype.slice.call(root.querySelectorAll('[data-ns-sticky-stop]'));
    var lightbox = root.querySelector('[data-ns-lightbox]');
    var lightboxImg = root.querySelector('[data-ns-lightbox-img]');
    var lightboxCap = root.querySelector('[data-ns-lightbox-cap]');
    var lightboxCount = root.querySelector('[data-ns-lightbox-count]');
    var lightboxStage = root.querySelector('[data-ns-lightbox-stage]');
    var allSamples = Array.prototype.slice.call(root.querySelectorAll('[data-ns-sample]'));
    var activeSamples = allSamples;
    var currentSample = 0;
    var returnFocus = null;
    var stickyWasVisible = false;
    var touchStartX = null;
    var touchStartY = null;

    function stickyStopVisible() {
      return stickyStops.some(function (element) {
        var rect = element.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      });
    }

    function updateSticky() {
      if (!sticky || sticky.classList.contains('is-suppressed')) return;
      var heroPassed = !heroCta || heroCta.getBoundingClientRect().bottom < 8;
      sticky.classList.toggle('is-visible', heroPassed && !stickyStopVisible());
    }

    function setActiveGroup(group) {
      activeSamples = allSamples.filter(function (button) {
        return !group || button.getAttribute('data-ns-group') === group;
      });
      if (!activeSamples.length) activeSamples = allSamples;
    }

    function setSample(index) {
      if (!activeSamples.length || !lightboxImg) return;
      currentSample = (index + activeSamples.length) % activeSamples.length;
      var button = activeSamples[currentSample];
      var label = button.getAttribute('data-label') || 'Sample page';
      lightboxImg.src = button.getAttribute('data-src');
      lightboxImg.alt = label;
      if (lightboxCap) lightboxCap.textContent = label;
      if (lightboxCount) lightboxCount.textContent = (currentSample + 1) + ' / ' + activeSamples.length;
    }

    function openLightbox(button, opener) {
      if (!lightbox || !button) return;
      setActiveGroup(button.getAttribute('data-ns-group'));
      currentSample = Math.max(0, activeSamples.indexOf(button));
      stickyWasVisible = !!(sticky && sticky.classList.contains('is-visible'));
      if (sticky) sticky.classList.add('is-suppressed');
      returnFocus = opener || document.activeElement;
      setSample(currentSample);
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ns-modal-open');
      var close = lightbox.querySelector('[data-ns-lightbox-close]');
      if (close) close.focus();
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ns-modal-open');
      if (sticky) {
        sticky.classList.remove('is-suppressed');
        sticky.classList.toggle('is-visible', stickyWasVisible && !stickyStopVisible());
      }
      if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus();
      returnFocus = null;
    }

    allSamples.forEach(function (button) {
      button.addEventListener('click', function () { openLightbox(button, button); });
    });

    var previewButton = root.querySelector('[data-ns-open-guide-preview]');
    if (previewButton) {
      previewButton.addEventListener('click', function () {
        var firstGuide = root.querySelector('[data-ns-sample][data-ns-group="guide"]');
        if (firstGuide) openLightbox(firstGuide, previewButton);
      });
    }

    root.querySelectorAll('[data-ns-sample-prev]').forEach(function (button) {
      button.addEventListener('click', function () { setSample(currentSample - 1); });
    });
    root.querySelectorAll('[data-ns-sample-next]').forEach(function (button) {
      button.addEventListener('click', function () { setSample(currentSample + 1); });
    });
    root.querySelectorAll('[data-ns-lightbox-close]').forEach(function (button) {
      button.addEventListener('click', closeLightbox);
    });

    if (lightboxStage) {
      lightboxStage.addEventListener('touchstart', function (event) {
        if (!event.touches.length) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      }, { passive: true });
      lightboxStage.addEventListener('touchend', function (event) {
        if (touchStartX === null || touchStartY === null || !event.changedTouches.length) return;
        var deltaX = event.changedTouches[0].clientX - touchStartX;
        var deltaY = event.changedTouches[0].clientY - touchStartY;
        touchStartX = null;
        touchStartY = null;
        if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY)) {
          setSample(currentSample + (deltaX < 0 ? 1 : -1));
        }
      }, { passive: true });
    }

    if (lightbox) {
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) closeLightbox();
      });
      lightbox.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeLightbox();
          return;
        }
        if (event.key === 'ArrowLeft') { event.preventDefault(); setSample(currentSample - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); setSample(currentSample + 1); }
        if (event.key !== 'Tab') return;

        var focusable = Array.prototype.slice.call(lightbox.querySelectorAll(
          'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
        )).filter(function (element) { return element.offsetParent !== null; });
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    root.querySelectorAll('.ns-faq details').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        root.querySelectorAll('.ns-faq details[open]').forEach(function (other) {
          if (other !== details) other.open = false;
        });
      });
    });

    var stickyScheduled = false;
    function scheduleStickyUpdate() {
      if (stickyScheduled) return;
      stickyScheduled = true;
      window.requestAnimationFrame(function () {
        stickyScheduled = false;
        updateSticky();
      });
    }
    window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
    window.addEventListener('resize', scheduleStickyUpdate);
    updateSticky();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ns-landing]').forEach(initLanding);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
